import { Link } from "react-router-dom";

export default function ConsignorCarousel({ consignors }) {
  const items = consignors.filter((c) => c.family_photo_url);
  if (items.length === 0) return null;
  const loop = [...items, ...items];

  return (
    <div className="consignor-marquee" data-testid="consignor-carousel">
      <div className="consignor-marquee-track" style={{ animationDuration: `${items.length * 6}s` }}>
        {loop.map((c, i) => (
          <Link
            key={`${c.id}-${i}`}
            to={c.slug ? `/consignor/${c.slug}` : "/consignors"}
            className="consignor-marquee-card group"
            data-testid={i < items.length ? `carousel-card-${i}` : undefined}
            aria-hidden={i >= items.length}
            tabIndex={i >= items.length ? -1 : 0}
          >
            <div className="consignor-marquee-frame">
              <img
                src={c.family_photo_url}
                alt={c.name}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
              />
              <div className="consignor-marquee-shade" />
              <div className="consignor-marquee-label">
                <div className="font-display text-xl md:text-2xl leading-tight" style={{ color: "#FFFFFF" }}>
                  {c.name}
                </div>
                {c.location && (
                  <div className="eyebrow text-[9px] mt-1" style={{ color: "#E8D7A8", letterSpacing: "0.22em" }}>
                    {c.location}
                  </div>
                )}
              </div>
            </div>
          </Link>
        ))}
      </div>

      <style>{`
        .consignor-marquee {
          overflow: hidden;
          position: relative;
          -webkit-mask-image: linear-gradient(to right, transparent 0, black 5%, black 95%, transparent 100%);
          mask-image: linear-gradient(to right, transparent 0, black 5%, black 95%, transparent 100%);
        }
        .consignor-marquee-track {
          display: flex;
          gap: 20px;
          width: max-content;
          animation-name: consignor-scroll;
          animation-timing-function: linear;
          animation-iteration-count: infinite;
          will-change: transform;
        }
        .consignor-marquee:hover .consignor-marquee-track { animation-play-state: paused; }
        @keyframes consignor-scroll {
          from { transform: translateX(0); }
          to   { transform: translateX(calc(-50% - 10px)); }
        }
        .consignor-marquee-card { display: block; flex-shrink: 0; }
        .consignor-marquee-frame {
          position: relative;
          width: 330px;
          height: 260px;
          overflow: hidden;
          border: 1px solid var(--border-subtle);
          background: var(--bg-secondary);
        }
        @media (max-width: 640px) {
          .consignor-marquee-frame { width: 250px; height: 200px; }
        }
        .consignor-marquee-shade {
          position: absolute; inset: 0;
          background: linear-gradient(to top, rgba(7,17,28,0.85) 0%, rgba(7,17,28,0.15) 45%, transparent 70%);
          pointer-events: none;
        }
        .consignor-marquee-label {
          position: absolute; left: 16px; right: 16px; bottom: 12px;
        }
        @media (prefers-reduced-motion: reduce) {
          .consignor-marquee-track { animation: none; }
        }
      `}</style>
    </div>
  );
}
